import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AdService} from '@services/ad.service';
import {AlertService} from '@services/alert.service';
import {AiCreditService} from '@services/ai-credit.service';
import {TrackingService} from '@services/tracking.service';

@Component({
    selector: 'app-config-dpe-tools',
    templateUrl: './config-dpe-tools.component.html',
    styleUrls: ['./config-dpe-tools.component.scss']
})
export class ConfigDpeToolsComponent implements OnInit {

    refAdeme = '';
    loading = false;
    result = '';
    analysedRef = '';
    analysedDate = '';
    blockedKind: '' | 'credit' | 'plan' = '';
    blockedMessage = '';

    // L'analyse coûte une minute : on redonne la dernière au retour sur l'outil.
    private storageKey = 'lybox_tool_dpe';

    constructor(
        private route: ActivatedRoute,
        private adService: AdService,
        public aiCreditService: AiCreditService,
        private alertService: AlertService,
        public trackingService: TrackingService) {
    }

    ngOnInit() {
        this.loadCachedAnalysis();
        this.refreshBlocked();

        this.route.queryParams.subscribe(params => {
            if (params.ref_ademe != undefined && params.ref_ademe != '') {
                this.refAdeme = params.ref_ademe;
                this.analyse();
            }
        });
    }

    analyse() {
        const ref = this.refAdeme.trim();
        if (ref === '' || this.loading || this.blockedKind !== '') {
            return;
        }

        this.loading = true;
        this.trackingService.click('ai_analysis_tool_dpe_start', ref);
        this.adService.analyseDpe(ref).subscribe(response => {
            this.loading = false;
            this.trackingService.click('ai_analysis_tool_dpe_success', ref);
            this.aiCreditService.applyResponse(response);
            this.refreshBlocked();
            this.setAnalysis({
                ref: response.ref_ademe ? response.ref_ademe : ref,
                result: response.result,
                date: new Date().toISOString()
            });
        }, error => {
            this.loading = false;
            const aiError = this.aiCreditService.handleError(error);
            this.trackingService.click('ai_analysis_tool_dpe_error_' + aiError.kind, ref);
            if (aiError.kind === 'ignore') {
                return;
            }
            if (aiError.kind === 'credit' || aiError.kind === 'plan') {
                this.blockedKind = aiError.kind;
                this.blockedMessage = aiError.message;
                return;
            }
            this.refreshBlocked();
            // Le back renvoie un message explicite (numéro invalide, DPE introuvable,
            // open data ADEME indisponible) : on l'affiche tel quel.
            this.alertService.error(aiError.message);
        });
    }

    // Le solde seul ne suffit pas : un essai terminé laisse ses crédits non consommés en base.
    refreshBlocked() {
        if (!this.aiCreditService.hasPlan) {
            this.blockedKind = 'plan';
            this.blockedMessage = 'Un abonnement est nécessaire pour lancer une analyse IA.';
        } else if (this.aiCreditService.credit <= 0) {
            this.blockedKind = 'credit';
            this.blockedMessage = 'Vous n\'avez plus de crédit d\'analyse IA.';
        } else {
            this.blockedKind = '';
            this.blockedMessage = '';
        }
    }

    newAnalysis() {
        this.result = '';
        this.analysedRef = '';
        this.analysedDate = '';
        localStorage.removeItem(this.storageKey);
    }

    private setAnalysis(cached: { ref: string, result: string, date: string }) {
        localStorage.setItem(this.storageKey, JSON.stringify(cached));
        this.refAdeme = cached.ref;
        this.analysedRef = cached.ref;
        this.analysedDate = cached.date;
        this.result = cached.result;
    }

    private loadCachedAnalysis() {
        const stored = localStorage.getItem(this.storageKey);
        if (!stored) {
            return;
        }
        try {
            const cached = JSON.parse(stored);
            this.refAdeme = cached.ref;
            this.analysedRef = cached.ref;
            this.analysedDate = cached.date;
            this.result = cached.result;
        } catch (e) {
            localStorage.removeItem(this.storageKey);
        }
    }
}
